<template>
  <div class="list-box">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="组织" name="first"></el-tab-pane>
      <el-tab-pane v-if="type === '1'" label="终端" name="second"></el-tab-pane>
    </el-tabs>
    <el-row>
      <el-col :span="20" :offset="1">
        <h5>包含</h5>
        <vxe-toolbar v-if="notView">
          <template v-slot:buttons>
            <vxe-button @click="addTable()">添加</vxe-button>
            <vxe-button v-if="type === '1' && tabType === 'second'"  @click="downloadTemplate()">下载导入模板</vxe-button>
            <vxe-button
              v-if="type === '1' && tabType === 'second'"
              style="position:relative"
              >导入
              <input
                type="file"
                id="file1"
                ref="files"
                style="opacity:0;width:100%;height:100%;position:absolute;top:0;left:0;"
                @change="upload"
              />
            </vxe-button>
            <vxe-button @click="deleteTable()">删除</vxe-button>
          </template>
        </vxe-toolbar>
        <vxe-table
          :align="allAlign"
          @checkbox-all="
            ({ records }) => selectAllEvent('firstSelect', records)
          "
          @checkbox-change="
            ({ records }) => selectChangeEvent('firstSelect', records)
          "
          :data="activeName === 'first' ? firstTableData : showTableData"
          style="max-height: 400px; overflow: auto"
        >
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column
            v-for="(config, index) in firstColumn"
            :key="index"
            v-bind="config"
          ></vxe-table-column>
        </vxe-table>
        <el-pagination
          v-if="type === '1' && tabType === 'second'"
          :current-page.sync="pageVO.currentPage"
          :page-sizes="[50, 100, 200, 500]"
          :page-size="pageVO.pageSize"
          layout="sizes, prev, pager, next"
          :total="pageVO.total"
          style="margin-top: 20px;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </el-col>
    </el-row>

    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import request from '@/found/utils/request';

const orgColumn = [
  { field: 'orgCode', title: '组织编码' },
  { field: 'orgName', title: '组织名称' },
];
const terColumn = [
  { field: 'terminalCode', title: '终端编码' },
  { field: 'terminalName', title: '终端名称' },
];

export default {
  name: 'NoticeManageTableForm',
  components: {
    SelectConfig,
  },
  props: {
    value: Object,
    notView: Boolean,
    type: String,
  },
  watch: {
    value() {
      if (this.tabType === 'first') {
        this.firstTableData = this.value.orgList;
      } else if (this.tabType === 'second') {
        this.firstTableData = this.value.terminalList;
      }
    },
    type: {
      immediate: true,
      deep: true,
      handler(val) {
        // if (val === '2') {
        //   this.activeName = 'first';
        //   this.tabType = 'first';
        //   this.firstColumn = orgColumn;
        //   this.firstTableData = this.value.orgs;
        // } else if (val === '1') {
        //   this.activeName = 'second';
        //   this.tabType = 'second';
        //   this.firstColumn = terColumn;
        //   this.firstTableData = this.value.terminalList || [];
        // }
      },
    },
  },
  data() {
    return {
      modalConfig: {}, // 弹框信息
      activeName: 'first',
      allAlign: null,
      firstColumn: orgColumn,
      firstTableData: [],
      tabType: 'first',
      firstSelect: [],
      showTableData: [],
      pageVO: {
        total: 0,
        currentPage: 1,
        pageSize: 50,
      },
    };
  },
  created() {},
  methods: {
    handleClick(tab) {
      this.tabType = tab.name;
      if (tab.name === 'second') {
        this.firstColumn = terColumn;
        this.firstTableData = this.value.terminalList;
        this.pageVO.total = this.value.terminalList.length;
        this.showTableData = this.value.terminalList.slice((this.pageVO.currentPage - 1) * this.pageVO.pageSize, this.pageVO.currentPage * this.pageVO.pageSize);
      } else if (tab.name === 'first') {
        this.firstColumn = orgColumn;
        this.firstTableData = this.value.orgList;
      }
    },
    handleSizeChange(val) {
      this.pageVO.pageSize = val;
      this.showTableData = this.firstTableData.slice((this.pageVO.currentPage - 1) * this.pageVO.pageSize, this.pageVO.currentPage * this.pageVO.pageSize);
    },
    handleCurrentChange(val) {
      this.pageVO.currentPage = val;
      this.showTableData = this.firstTableData.slice((this.pageVO.currentPage - 1) * this.pageVO.pageSize, this.pageVO.currentPage * this.pageVO.pageSize);
    },
    addTable() {
      let params;
      if (this.tabType === 'first') {
        const selectionList = [];
        const list = this.firstTableData || [];
        list.forEach((v) => {
          selectionList.push(v.orgCode);
        });
        params = {
          functionCode: 'dms_noice_org',
          data: list,
          selectionList,
          idKey: 'orgCode',
        };
      } else if (this.tabType === 'second') {
        const selectionList = [];
        const list = this.firstTableData || [];
        list.forEach((v) => {
          selectionList.push(v.terminalCode);
        });
        params = {
          functionCode: 'choose-terminal-list',
          data: list,
          selectionList,
          idKey: 'terminalCode',
          paramData: {
            enableStatus: '009',
          },
        };
      }
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      if (this.tabType === 'second') {
        this.value.terminalList = val;
        this.value.orgList = [];
        this.firstTableData = val;
        this.pageVO.total = val.length;
        this.showTableData = val.slice((this.pageVO.currentPage - 1) * this.pageVO.pageSize, this.pageVO.currentPage * this.pageVO.pageSize);
      } else if (this.tabType === 'first') {
        this.value.orgList = val;
        this.value.terminalList = [];
        this.firstTableData = val;
      }
    },
    deleteTable() {
      const list = [];
      const code = this.tabType === 'second' ? 'terminalCode' : 'orgCode';
      this.firstTableData.forEach((v) => {
        let notSelect = true;
        if (this.firstSelect.filter((a) => a[code] === v[code]).length > 0) {
          notSelect = false;
        }
        if (notSelect) {
          list.push(v);
        }
      });
      this.firstTableData = list;
      this.firstSelect = [];
      if (this.tabType === 'second') {
        this.value.terminalList = this.firstTableData;
        this.pageVO.currentPage = 1;
        this.pageVO.total = this.firstTableData.length;
        this.showTableData = this.firstTableData.slice((this.pageVO.currentPage - 1) * this.pageVO.pageSize, this.pageVO.currentPage * this.pageVO.pageSize);
      } else if (this.tabType === 'first') {
        this.value.orgList = this.firstTableData;
      }
    },
    selectChangeEvent(val, records) {
      this[val] = records;
    },
    selectAllEvent(val, records) {
      this[val] = records;
    },
    // 关闭弹窗
    closeModal() {
      this.modalConfig = { ...this.modalConfig, visible: false };
    },
    downloadTemplate() {
      const file = new XMLHttpRequest();
      file.open('GET', '/cps/v1/fxhNotice/exportTerminalTemplate', true);
      file.responseType = 'blob';
      file.onload = () => {
        const content = file.response;
        const link = document.createElement('a');
        link.download = '终端导入模板.xlsx';
        link.style.display = 'none';
        const blob = new Blob([content]);
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      };
      file.send();
    },
    async upload() {
      const loading = this.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
      });
      const fileObj = document.getElementById('file1').files; // js 获取文件对象
      const form = new FormData();
      form.append('file', fileObj[0]);
      const result = await request.post('/cps/v1/fxhNotice/importExcelTerminal', form);
      if (result.success) {
        this.firstTableData = result.result || [];
        this.value.terminalList = result.result || [];
        this.pageVO.total = result.result.length;
        loading.close();
      } else {
        this.$message.error(result.message || '导入失败');
        loading.close();
      }
    },
  },
};
</script>

<style lang="less" scoped>
</style>
